import React from "react";
import { useTranslation } from "react-i18next";

interface ApplicationHeaderProps {
  propertyName: string;
  unitName: string;
  moveInDate: string;
}

const ApplicationHeader: React.FC<ApplicationHeaderProps> = ({
  propertyName,
  unitName,
  moveInDate,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6 rounded-xl bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-semibold text-primary">{propertyName}</p>
          <p className="text-sm text-muted">{unitName}</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted">{t("application.moveInDate")}</p>
          <p className="font-semibold text-primary">{moveInDate}</p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationHeader;
